/** CAMPAIGN W1 — the assembled beat table. Future acts append their data here. */
import type { CampaignBeat } from './campaign.js';
import { ACT0_BEATS } from './act0.js';
import { ACT1_BEATS } from './act1.js';

export const CAMPAIGN_BEATS: readonly CampaignBeat[] = [...ACT0_BEATS, ...ACT1_BEATS];
